import * as React from 'react';

import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  heading: string;
  actions?: React.ReactNode;
  cta?: React.ReactNode;
}

export default class ClowncarHeader extends BaseComponent<Props> {
  render() {
    const { heading, actions, cta } = this.props;

    return (
      <div className="ClowncarHeader">
        <div className="ClowncarHeader-content">
          {heading}
          {actions && <div className="ClowncarHeader-actions">{actions}</div>}
          {cta}
        </div>
      </div>
    );
  }
}
